import axiosWrapper from '../helpers/api'
import { ERequestUrl, EMethods } from '../helpers/requests'
import { FinalizePaymentData } from '../types/paymentType'
import { apiHeaders } from '../../utils/utils'
import { LOCAL_STORAGE_KEYS } from '@/utils/constants'

export const postDadPayment = (data, token) => {
  const storesWithBearerToken = ['thermor-2ndhand', 'atlantic-2ndhand']
  const shouldSendBearerToken = storesWithBearerToken.includes(
    process.env.STORE
  )
  const authToken =
    typeof window !== 'undefined' && shouldSendBearerToken
      ? localStorage?.getItem(LOCAL_STORAGE_KEYS.TOKEN)
      : null
  const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {}

  return axiosWrapper({
    method: EMethods.post,
    url: ERequestUrl.payment,
    data: data,
    uid: `${token}/complete-dad-order`,
    // headers: headers,
  })
}

export const postBypassDadPayment = (data, token) => {
  const authToken = localStorage?.getItem(LOCAL_STORAGE_KEYS.TOKEN)
  const headers = authToken
    ? apiHeaders(localStorage.getItem(LOCAL_STORAGE_KEYS.CONNEXION_TYPE))
    : {}
  return axiosWrapper({
    method: EMethods.post,
    url: ERequestUrl.payment,
    data: data,
    uid: `bypass/${token}/complete-dad-order`,
    headers: headers,
  })
}

export const postSubPayment = (data, token) =>
  axiosWrapper({
    method: EMethods.post,
    url: ERequestUrl.payment,
    data: data,
    headers: apiHeaders(localStorage.getItem('connexion-type')),
    uid: `${token}/complete-sub-order`,
  })

export const postWireTransferDadPayment = (data, token) => {
  const authToken = localStorage?.getItem(LOCAL_STORAGE_KEYS.TOKEN)
  const headers = authToken
    ? apiHeaders(localStorage.getItem(LOCAL_STORAGE_KEYS.CONNEXION_TYPE))
    : {}
  return axiosWrapper({
    method: EMethods.post,
    url: ERequestUrl.payment,
    data: data,
    uid: `wire-transfer/${token}/complete-dad-order`,
    headers: headers,
  })
}

export const postFinalizeDadPayment = (
  data: FinalizePaymentData,
  token: string
) =>
  axiosWrapper({
    method: EMethods.post,
    url: ERequestUrl.payment,
    data: data,
    uid: `${token}/finalize-post-payment`,
  })
